export default function ivp_log(message, type) {
  let msg = '';
  switch (type) {
    case 'info':
      msg = '📒 ';
      break;
    case 'error':
      msg = '📕 ';
      break;
    case 'warn':
      msg = '📙 ';
      break;
    case 'ok':
      msg = '📗 ';
      break;
    case 'action':
      msg = '📘 ';
      break;
    default:
      msg = '📓 ';
      break;
  }
  Window.debug ? console.log(`${msg + message}`) : null;
}
